import React from 'react'
import cx from 'classnames'

import { TComponentBase } from '../../types/componentBase'

type TContainerProps = {
  as?: React.ElementType
  ref?: React.Ref<HTMLElement>
}

const Container = React.forwardRef<HTMLElement, TContainerProps & TComponentBase>((props, ref) => {
  const className = cx(
    'w-full mx-auto px-16 sm:p-0 sm:uif-max-w-718 md:uif-max-w-942 lg:uif-max-w-1160',
    props.className,
  )
  const Element = props.as || 'div'
  return (
    <Element className={className} style={props.style} ref={ref} onClick={props.onClick}>
      {props.children}
    </Element>
  )
})

Container.displayName = 'Grid.Container'

export { Container as default, TContainerProps }
